import { render, staticRenderFns } from "./AdmissionsAssessmentsList.vue?vue&type=template&id=52cdc492&"
import script from "./AdmissionsAssessmentsList.vue?vue&type=script&lang=js&"
export * from "./AdmissionsAssessmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports